import React, { useCallback, useEffect, useState } from 'react'
import Page, { Container, PageHeader, Row } from '@zera-admin/page'
import Spinner from '@zera-admin/spinner'
import Breadcrumb, { BreadcrumbItem } from '@zera-admin/breadcrumb'
import MainLayout from 'layouts/main'
import { NewsFeedV1SettingsProps } from 'services/http/backoffice/news-source/external-news-feed-v1-settings'
import { LoadingView } from './NewsFeedV1Settings.styled'
import * as Styled from './NewsFeedV1Settings.styled'
import NewsSourceEditor from './components/NewsSourceEditor'
import { get, update } from 'services/http/backoffice/news-source/external-news-feed-v1-settings'

const NewsFeedV1Settings: React.FunctionComponent<NewsFeedV1SettingsProps> = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [isSaving, setIsSaving] = useState<boolean>(false)
  const [newsSources, setNewsSources] = useState<string[]>([])

  const fetchSettings = useCallback(async () => {
    setIsLoading(true)
    try {
      const response = await get()
      
      if (response.data.statusCode === 200) {
        setNewsSources(response.data.data.newsSources)
      } else {
        console.error('Ayarlar yüklenirken hata oluştu:', response.data)
      }
    } catch (error) {
      console.error('Ayarlar yüklenirken hata oluştu:', error)
    } finally {
      setIsLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchSettings()
  }, [fetchSettings])

  const handleSaveSettings = async (updatedNewsSources: string[]) => {
    setIsSaving(true)
    try {
      const response = await update({ newsSources: updatedNewsSources })
      if (response.code === 200 || response.code === 201) {
        // Başarılı kaydetme sonrası ayarları yeniden yükle
        await fetchSettings()
      } else {
        console.error('Ayarlar kaydedilirken hata oluştu:', response.data)
        alert('Ayarlar kaydedilirken bir hata oluştu!')
      }
    } catch (error) {
      console.error('Ayarlar kaydedilirken hata oluştu:', error)
      alert('Ayarlar kaydedilirken bir hata oluştu!')
    } finally {
      setIsSaving(false)
    }
  }

  if (isLoading) {
    return (
      <LoadingView>
        <Spinner size="large" />
        <h5>Ayarlar yükleniyor...</h5>
      </LoadingView>
    )
  }

  return (
    <MainLayout isLoading={false}>
      <Page>
        <PageHeader
          breadcrumbs={
            <Breadcrumb>
              <BreadcrumbItem text="Anasayfa" href="/" />
              <BreadcrumbItem text="Haber Akışı V1 Ayarları" />
            </Breadcrumb>
          }
        >
          Haber Akışı V1 Ayarları
        </PageHeader>
        <Styled.SettingsContainer>
          <NewsSourceEditor
            newsSources={newsSources}
            onSave={handleSaveSettings}
            isSaving={isSaving}
          />
        </Styled.SettingsContainer>
      </Page>
    </MainLayout>
  )
}

export default NewsFeedV1Settings
